<template>  

<section :style="{'background-image':'url(assets/Testimonial.png)'}" class="testimonial_bg">
<div class="container">
<div class="test_bg">
<div class="box">

<h1 class="txt_style"> Testimonials </h1>
<p> Here is the customer reviews we consider for all things we have for another </p>

<div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
    <div class="row">
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person1.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person2.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person3.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    </div>    
    </div>
    <div class="carousel-item">
       <div class="row">
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person1.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person2.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person3.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    </div>
    </div>
    <div class="carousel-item">
    <div class="row">
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person2.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person1.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
            <div class="card style">
                <div class="enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="/assets/img-person3.png">
                </div>
                </div>

                </div>
                    <div class="row text-center" style="padding: 19px">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum   </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-quote-left" aria-hidden="true"></i>
                        <p class="message-client"> Description is like something we need for.Description is like something we need for.Description is like something we need for.</p>
                    </div>
                    </div>
                </div>
            </div>  
    </div>
    </div>
    </div>
  </div>
  <a class="carousel-control-prev" data-bs-target="#carouselExampleControls"  data-bs-slide="prev">
    <span class="carousel-control-prev-icon btn_carousel text-white" aria-hidden="true"></span>
    <!-- <span class="visually-hidden">Previous</span> -->
  </a>
  <a class="carousel-control-next" data-bs-target="#carouselExampleControls"  data-bs-slide="next">
    <span class="carousel-control-next-icon btn_carousel text-white" aria-hidden="true"></span>
    <!-- <span class="visually-hidden">Next</span> -->
  </a>
</div>

</div>
</div>
</div>
</section>


</template>


<script>


export default {
    name: 'Testimonials',
};


</script>

<style scoped>



.carousel-control-prev
{
    left: -110px;
   
}

.carousel-control-next 
{
    right: -110px;
    
}

.btn_carousel 
{
filter: invert(1); 
/* color: black; */
/* background-color:#378475; */
/* background-color:#378475 !important; */
}

.btn_carousel:hover
{
filter: invert(1);
/* background: linear-gradient(90deg, #1F4F46 5%, #55c0ab 190%); */
/* box-shadow: 1px 1px 6px -2px #378475 !important; */
border-radius: 250px;
}

.blockquote-custom {
  position: relative;
  font-size: 1.1rem;
  
}

.bg-info {
    background-color:#378475 !important;
}


.bg-info:hover{
  
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
}

.text-info {
    color: #ff1616 !important;
}

.blockquote-custom-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -25px;
  left: 50px;
  background-color:#378475;
  border: 3px solid white;
}




/* .btn_carousel
{
   color: #1F4F46;
} */


/* .carousel-control-prev-icon
{
    background-color: #1F4F46 !important;
} 

.carousel-control-next-icon
{
     background-color: #1F4F46 !important;
} */

.testimonial-card
{    
border: 1px solid #ddd; 
border-radius: 5px;
margin: 0px 0;
background-color: white;
}
.card.style i {
    background-color: #1F4F46;
    padding: 10px;
    border-radius: 50%;
    color: white;
    margin: 15px 0;
}
p.message-client {
    text-align: justify;
    line-height: 20px;
    font-size: 13px !important;
    height: 80px;
    overflow: hidden;
}
.icon_box img {
    margin-top: -65px;
    width: 120px;
    height: 120px;
    object-fit: cover;
}

.testimonial_bg
{
    padding-bottom: 30px;
    height: 100% ;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;  
}

.box
{
    width: 1100px;
    background-color: #FCFCFC;
    padding: 29px 80px 65px;
    box-shadow: 0px 0px 5px 0px rgb(161 163 164);
    margin: 50px auto;
}



.test_bg
{
padding-top: 45px;
}

.txt_style
{
  font-weight: bolder;
  margin-top: 12px;
}

.card {
    position: relative;
    display: inline-block;
    flex-direction: column;
    width: 100%;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0;
    border-radius: 0;
    box-shadow: 0px 0px 10px -2px rgb(193 194 195);
    margin-top: 60px;
    padding: 20px !important;
    margin-bottom: 10px;
 }
.card p{
    font-size: 11px;
    font-weight: normal;
    color: #9f9f9f;
}
 .card .card-body {
     padding: 1rem 1rem
 }

 .card-body {
     flex: 1 1 auto;
     padding: 1.25rem
 }

 p {
     font-size: 0.875rem;
     margin-bottom: .5rem;
     line-height: 1.5rem
 }

 h4 {
     line-height: .2 !important
 }

 .profile {
     margin-top: 16px;
     margin-left: 11px
 }

 .profile-pic {
     width: 58px
 }

 .cust-name {
     font-size: 18px
 }

 .cust-profession {
     font-size: 10px
 }

 .items {
     width: 90%;
     margin: 0px auto;
     margin-top: 30px
 }

 .slick-slide
 {
     margin: 10px
 }


@media (min-width: 1504px) and (max-width: 2000px) 
{



}


@media (min-width: 1200px) and (max-width: 1503px) 
{


}

@media (min-width: 992px) and (max-width: 1199px) 
{

.card
{
    margin-bottom: 30px;
}



.box{
    width: 891px;
    background-color: #FCFCFC;
    box-shadow: 0px 0px 5px 0px rgb(161 163 164);
    margin: -50px auto;
    margin-top: 10px;
    margin-bottom: 10px;
}






}

@media (min-width: 768px) and (max-width: 991px) 
{

.card 
{
    margin-bottom: 30px;

}

.box {

    width: auto !important; 
    background-color: #FCFCFC;
    padding: 10px 30px 30px;
    box-shadow: 0px 0px 5px 0px rgb(161 163 164);
    margin: 50px auto;
}





}


@media (min-width: 576px) and (max-width: 767px) 
{


    .box {
    width: auto !important; 
    background-color: #FCFCFC;
    padding: 10px 30px 30px;
    box-shadow: 0px 0px 5px 0px rgb(161 163 164);
    margin: 50px auto;
}

}


@media (min-width: 320px) and (max-width: 575px) 
{

   .box {
    width: auto !important; 
    background-color: #FCFCFC;
    padding: 10px 30px 30px;
    box-shadow: 0px 0px 5px 0px rgb(161 163 164);
    margin: 50px auto;
}




  
}

</style>

